import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalState } from "../data/Context";
import { resolveContractLandingPath, resolveDashboardPath } from "../data/authStorage";
import useCurrentEmployee from "../hooks/useCurrentEmployee";

const Index = () => {
  const { sidebarList, organization } = useContext(GlobalState);
  const { currentEmployee, loading, companyAccount } = useCurrentEmployee();
  let navigate = useNavigate();
  useEffect(() => {
    if (!companyAccount && loading) return;
    navigate(currentEmployee?.isContractor
      ? resolveContractLandingPath(currentEmployee.modulePermissions || [])
      : resolveDashboardPath(organization), { replace: true });
  }, [navigate, organization, sidebarList, currentEmployee, loading, companyAccount]);
  return <></>;
};

export default Index;
